// @ts-nocheck
import CryptoJS from "crypto-js";
import { createCipheriv, createDecipheriv } from "crypto";

const algorithm = "aes-256-cbc";

// 고정된 키와 IV 설정 (실제 사용시 안전한 방법으로 관리 필요)
const key = Buffer.from("hexx-32-byte-long-key-here-12345", "utf8"); // 32바이트 키
const iv = Buffer.from("hexx-16-bytehere", "utf8"); // 16바이트 IV

// 암호화
export function encryptHex(text: string) {
  const cipher = createCipheriv(algorithm, key, iv);
  let encrypted = cipher.update(text, "utf8", "hex");
  encrypted += cipher.final("hex");
  return encrypted;
}

// 복호화
export function decryptHex(encryptedText: string) {
  const decipher = createDecipheriv(algorithm, key, iv);
  let decrypted = decipher.update(encryptedText, "hex", "utf8");
  decrypted += decipher.final("utf8");
  return decrypted;
}

export function aes256Encrypt(plainText: string) {
  // 16바이트 IV 생성 (여기서는 임의의 IV를 생성, 실제 사용시 고정된 IV 사용 또는 동적으로 생성)
  const iv = CryptoJS.lib.WordArray.random(16);

  // 암호화
  const encrypted = CryptoJS.AES.encrypt(
    plainText,
    CryptoJS.enc.Utf8.parse(process.env.NEXT_PUBLIC_AES_KEY as string),
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  // IV와 암호문 결합
  const combined = iv.concat(encrypted.ciphertext);

  // base64로 인코딩하여 반환
  return CryptoJS.enc.Base64.stringify(combined);
}

function aes256Decrypt(encodedText: string) {
  // base64 디코딩
  const decodedData = CryptoJS.enc.Base64.parse(encodedText);

  // IV와 암호문 추출
  const iv = CryptoJS.lib.WordArray.create(decodedData.words.slice(0, 4));
  const cipherText = CryptoJS.lib.WordArray.create(decodedData.words.slice(4));

  // 복호화
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: cipherText },
    CryptoJS.enc.Utf8.parse(process.env.NEXT_PUBLIC_AES_KEY as string),
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  // UTF-8 문자열로 디코딩하여 반환

  return decrypted.toString(CryptoJS.enc.Utf8);
}

export default aes256Decrypt;
